import { RootState } from "@/store/store";
import { explainWithAiAnomaliesFormattedDataSelector } from "@/store/explain-with-ai/selectors/explainWithAiAnomaliesFormattedDataSelector";

export const explainWithAiAnomaliesCountSelector = (
  state: RootState,
  index: number,
): number | undefined => {
  const formattedData = explainWithAiAnomaliesFormattedDataSelector(
    state,
    index,
  );

  if (!formattedData) {
    return;
  }
  return formattedData.totalCount;
};
